import { useState, useEffect } from "react";
import { useResizeDetector } from "react-resize-detector";

export const useWidgetVariant = (breakpoint = 500) => {
  const { width, ref } = useResizeDetector();
  const [variant, setVariant] = useState("single column");

  useEffect(() => {
    if (!width) return;

    if (width > breakpoint) {
      setVariant("double column");
    } else {
      setVariant("single column");
    }
  }, [width, breakpoint]);

  // Retornamos todo lo necesario para que el componente lo use
  return {
    ref,
    width,
    variant,
    isLargeSlot: variant === "double column",
  };
};
